// @react-compiler-disable

import { AutocompleteOption, useAutocomplete } from '@/common/presentation/hooks/useAutocomplete';

import { useGetSalesRegionsAutocompleteWithTakeQuery } from '@/common/infrastructure/gql/generated/schema';

type SalesRegion = NonNullable<
  NonNullable<NonNullable<ReturnType<typeof useGetSalesRegionsAutocompleteWithTakeQuery>['data']>['salesRegions']>['items']
>[number];

export const useListSalesRegionsAutocomplete = (
  searchTerm: string = '',
  debounceMs: number = 1000,
  onSalesRegionSelect?: (salesRegion: AutocompleteOption) => void,
  take: number = 10
) => {
  const { data, loading, error, refetch } = useGetSalesRegionsAutocompleteWithTakeQuery({
    variables: { skip: 0, search: searchTerm, take },
    fetchPolicy: 'cache-and-network'
  });

  return useAutocomplete<SalesRegion>({
    searchTerm,
    debounceMs,
    onSelect: onSalesRegionSelect,
    query: () => ({
      data: { items: data?.salesRegions?.items },
      loading,
      error,
      refetch
    }),
    transform: (salesRegion) => ({
      value: salesRegion.id ?? 0,
      label: salesRegion.salesRegionName ?? 'Unknown Sales Region'
    })
  });
};
